import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router'
import { useQuery, useMutation, useQueryClient } from 'react-query'

import { Container } from '../layout/AppLayout.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Header from "../shared/Header.js"
import { CurrentUserContext } from '../../App.js';
import { isAllowed } from '../shared/FeatureChecker.js';
import { useMutationClient } from '../shared/hooks.js'
import { useNotifications } from '../shared/Notifications.js'
import { CurrentCompanyContext } from '../../App.js'
import DigitalForm  from './DigitalsForm.js'


export default function NewDigitalsPage() {
  const navigate = useNavigate()
  const currentUser = useContext(CurrentUserContext)
  const currentCompany = useContext(CurrentCompanyContext)
  const notifications = useNotifications()
  const mutationClient = useMutationClient()


  useEffect(() => {
    if (currentUser) {
      const allowed = isAllowed({ user: currentUser, feature: "CREATE_LOGS_DIGITALS_IMPLEMENTATION" })
      if (!allowed) {
        navigate('/error?error=403')
      }
    }

  }, [currentUser])

  const mutation = useMutation(data => mutationClient.post(`logsdigitals`, { ...data, company_id: currentCompany && currentCompany.id }), {
    onSuccess: (data, variables, context) => {
      if (data.status === 200) {
        notifications.success('Implementación en proceso')
        navigate(`/digitals/implementation/${data.data.result.id}`)
      }
    },
    onError: () => {
      notifications.danger('Ha ocurrido un error al crear la implemtación')
    }
  })

  return (
    <Container>
      <Row>
        <Header title="Crear implementación" items={[
          { label: `Logs digitales`, to: "/digitals" },
          { label: `Crear implementación` },
        ]} />
      </Row>

      <Row className="mb-3">
        <Col className="col-12">
          <DigitalForm
            Digital={{}}
            save={data => mutation.mutate(data)}
            isLoading={mutation.isLoading}
          />
        </Col>
      </Row>
    </Container>
  )
}
